// Pulls float32 audio from the capture graph, converts to PCM16 LE, and posts to the main thread for Gemini upload.
const CAPTURE_WORKLET_SOURCE = `
class GeminiLivePcmCaptureProcessor extends AudioWorkletProcessor {
  process(inputs) {
    const inputChannel = inputs[0]?.[0]
    if (inputChannel) {
      const pcm16 = new Int16Array(inputChannel.length)
      for (let i = 0; i < inputChannel.length; i++) {
        const s = Math.max(-1, Math.min(1, inputChannel[i])) // clamp to [-1, 1] to guard against float32 overflow
        pcm16[i] = Math.round(s * 32767) // scale to int16 range
      }
      this.port.postMessage(
        { type: "input", pcm: new Uint8Array(pcm16.buffer), sampleRate },
        [pcm16.buffer]
      )
    }
    return true
  }
}
registerProcessor("gemini-live-pcm-capture", GeminiLivePcmCaptureProcessor)
`

export async function loadGeminiLivePcmCaptureWorklet(
  ctx: BaseAudioContext
): Promise<void> {
  const blob = new Blob([CAPTURE_WORKLET_SOURCE], {
    type: "application/javascript",
  })
  const url = URL.createObjectURL(blob)
  try {
    await ctx.audioWorklet.addModule(url)
  } finally {
    URL.revokeObjectURL(url)
  }
}
